/* global Swiper */
const mainSliderElements = document.querySelectorAll('[data-slider="main-slider"]');
const mainTumbnailSliderElements = document.querySelectorAll('[data-slider="main-thumbnail-slider"]');

// *******************************************************************************
// 1.0 - Tumbnail slider
// *******************************************************************************

Array.prototype.forEach.call(mainTumbnailSliderElements, (el) => {
  const mainTumbnailSliderOptions = {
    slidesPerView: 'auto',
    initialSlide: 0,
    spaceBetween: 20,
    autoplay: {
      delay: 5000,
      autoplayDisableOnInteraction: false,
    },
    speed: 1000,
    watchSlidesVisibility: true,
    watchSlidesProgress: true,
    breakpoints: {
      767: {
        slidesPerView: 4,
        spaceBetween: 30,
      },
    },
  };
  // eslint-disable-next-line no-unused-vars
  const mainThumbnailSlider = new Swiper(el, mainTumbnailSliderOptions);
});

// *******************************************************************************
// 2.0 - Main slider
// *******************************************************************************

Array.prototype.forEach.call(mainSliderElements, (el, i) => {
  const mainSliderParent = el.closest('.main-slider');
  const arrowRight = mainSliderParent.querySelectorAll('.arrow--right');
  const arrowLeft = mainSliderParent.querySelectorAll('.arrow--left');
  const mainSliderElementsOptions = {
    slidesPerView: 1,
    autoplay: {
      delay: 5000,
      autoplayDisableOnInteraction: false,
    },
    effect: 'fade',
    fadeEffect: {
      crossFade: true,
    },
    speed: 1000,
    spaceBetween: 0,
    navigation: {
      nextEl: arrowRight,
      prevEl: arrowLeft,
    },
    thumbs: {
      swiper: mainTumbnailSliderElements[i].swiper,
    },
    watchSlidesVisibility: true,
    watchSlidesProgress: true,
  };
  // eslint-disable-next-line no-unused-vars
  const mainSlider = new Swiper(el, mainSliderElementsOptions);
});
